(function () {
  function initTestimonials(root) {
    if (!root || root.dataset.wxTestiReady === '1') return;
    root.dataset.wxTestiReady = '1';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-wx-testi-slide]'));
    if (!slides.length) return;

    var counter = root.querySelector('[data-wx-testi-counter]');
    var fill = root.querySelector('[data-wx-testi-fill]');
    var prevBtn = root.querySelector('[data-wx-testi-prev]');
    var nextBtn = root.querySelector('[data-wx-testi-next]');
    var total = slides.length;
    var current = 0;
    var speedSec = parseFloat(root.getAttribute('data-speed')) || 7;
    var timer = null;

    function renderSlide() {
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === current);
      });
      if (counter) counter.textContent = current + 1 + ' / ' + total;
    }

    function clearTimer() {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    }

    function resetFill() {
      if (!fill) return;
      fill.classList.remove('is-running');
      fill.style.transition = 'none';
      fill.style.transform = 'scaleX(0)';
      void fill.offsetWidth;
    }

    function startFill() {
      if (total < 2) return;
      clearTimer();
      resetFill();

      if (fill) {
        fill.style.transition = 'transform ' + speedSec + 's linear';
        fill.classList.add('is-running');
        fill.style.transform = 'scaleX(1)';
      }

      timer = setTimeout(function () {
        next();
      }, speedSec * 1000);
    }

    function goTo(index) {
      current = ((index % total) + total) % total;
      renderSlide();
      startFill();
    }

    function next() {
      goTo(current + 1);
    }

    function prev() {
      goTo(current - 1);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        next();
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        prev();
      });
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        clearTimer();
        resetFill();
      } else {
        startFill();
      }
    });

    renderSlide();
    startFill();
  }

  function boot() {
    document.querySelectorAll('[data-wx-testimonials]').forEach(initTestimonials);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector('[data-wx-testimonials]');
    if (root) {
      delete root.dataset.wxTestiReady;
      initTestimonials(root);
    }
  });
})();
